import React from 'react';
import styles from './TagChannels.module.scss';

export const TagsChannel = ({channelsList, mask}) => {
    const ids = channelsList
        .filter(channel => (mask & channel.id) !== 0)
        .map(channel => channel.id);

    return (
        <>
            {ids.includes(1) && <TagEmail/>}
            {ids.includes(2) && <TagTelegram/>}
        </>
    );
};

export const TagTelegram = () => {
    return (
        <span className={`${styles.container} ${styles.telegram}`}>
            Телеграм
        </span>
    );
};

export const TagEmail = () => {
    return (
        <span className={`${styles.container} ${styles.email}`}>
            Email
        </span>
    );
};
